var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"ma-0 pa-0",attrs:{"flat":""}},[_c('v-card-text',{staticClass:"pa-0 pl-0"},[_c('SectionHeader',{attrs:{"icon":_vm.icon,"label":_vm.label,"id":_vm.id}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }